import React, { useRef, useState, useEffect } from "react";
import {
  FaCopy,
  FaFileUpload,
  FaPaperPlane,
  FaEdit,
  FaDownload,
  FaCheck,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import Cookies from "universal-cookie";
import axios from "axios";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import "../../css/ConsultaEnvio.css";
import { PiNutFill } from "react-icons/pi";

const ConsultaEnvio = () => {
  const cookies = new Cookies();

  const [usuario, setUsuario] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [estado, setEstado] = useState("");
  const [rangoFecha, setRangoFecha] = useState("7");
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [copiedCuv, setCopiedCuv] = useState(null);
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
  const [xmlValidado, setXmlValidado] = useState({});
  const [jsonFactura, setJsonFactura] = useState(null);
  const [mostrarPanelJSON, setMostrarPanelJSON] = useState(false);
  const [busquedaJson, setBusquedaJson] = useState(""); // búsqueda
  const [facturaEnPanel, setFacturaEnPanel] = useState(null); // factura actual
  const [esEditable, setEsEditable] = useState(false); // editable si está "Sin Enviar"
  const [cargando, setCargando] = useState(false);
  const [procesandoRegistro, setProcesandoRegistro] = useState(false);
  const [descargandoArchivos, setDescargandoArchivos] = useState(false);
  const [enviandoRips, setEnviandoRips] = useState(false);

  const [dataFacturas, setDataFacturas] = useState([]);

  const [mostrarModalCargaXML, setMostrarModalCargaXML] = useState(false);
  const archivoXmlRef = useRef(null);

  const fileInputRef = useRef(null);
  const elementosPorPagina = 15;
  const ambiente = "PRODUCCION";
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const textareaRef = useRef(null); // 1. Ref para el textarea
  const [cursorPos, setCursorPos] = useState(0); // Necesario para guardar la posición

  //Obtener las facturas cargadas, para llenar la tabla
  const obtenerFacturas = async () => {
    setCargando(true);
    try {
      const response = await axios.get(baseURL + "/api/Rips/VerFacturasRips");
      if (response.data.exito) {
        setDataFacturas(response.data.facturas);
        console.log(response.data.facturas);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.mensaje || "Ocurrió un error inesperado.",
        });
      }
    } catch (err) {
      console.error("Error al consultar facturas:", err);
      Swal.fire({
        icon: "error",
        title: "Conexión fallida",
        text: "No se pudo conectar con el servidor.",
      });
    } finally {
      setCargando(false);
    }
  };

  //Este metodo se inicia una vez se ingresa a la ventana
  useEffect(() => {
    setUsuario(cookies.get("nombreUsuario") || "");
    obtenerFacturas();
  }, []);

  //Validar fechas de filtro para la tabla
  const calcularFechaFiltro = () => {
    const hoy = new Date();
    let desde = new Date();

    if (rangoFecha === "7") desde.setDate(hoy.getDate() - 7);
    else if (rangoFecha === "30") desde.setDate(hoy.getDate() - 30);
    else if (rangoFecha === "90") desde.setDate(hoy.getDate() - 90);

    return {
      desde: desde.toISOString().split("T")[0],
      hasta: hoy.toISOString().split("T")[0],
    };
  };

  //Filotrs de la tabla
  useEffect(() => {
    const { desde, hasta } = calcularFechaFiltro();
    const filtrados = dataFacturas.filter((item) => {
      const fechaItem = item.fecha;

      const coincideBusqueda =
        (item.factura || "").toLowerCase().includes(busqueda.toLowerCase()) ||
        (item.cuv || "").toLowerCase().includes(busqueda.toLowerCase());

      const coincideEstado = estado === "" || item.estado === estado;
      const enRango = fechaItem >= desde && fechaItem <= hasta;

      return coincideBusqueda && coincideEstado && enRango;
    });

    setDatosFiltrados(filtrados);
    setPaginaActual(1);
  }, [busqueda, estado, rangoFecha, dataFacturas]);

  //Copiar el CUV
  const handleCopy = (cuv) => {
    navigator.clipboard.writeText(cuv);
    setCopiedCuv(cuv);
    setTimeout(() => setCopiedCuv(null), 1500);
  };

  //Una vez se selecciona el archivo, guardo la ruta del mismo en un input
  const handleCargarXML = (factura) => {
    setFacturaSeleccionada(factura); // Guardamos para saber a qué factura se carga
    fileInputRef.current.click(); // Abrimos explorador de archivos
  };

  const indexInicio = (paginaActual - 1) * elementosPorPagina;
  const indexFin = indexInicio + elementosPorPagina;
  const datosPaginados = datosFiltrados.slice(indexInicio, indexFin);
  const totalPaginas = Math.ceil(datosFiltrados.length / elementosPorPagina);

  //Validar el XML de la factura seleccionado
  const handleProcesarXMLSeleccionado = async (e) => {
    const archivo = e.target.files[0];
    if (archivo) {
      if (archivo.name.toLowerCase().endsWith(".xml")) {
        const formData = new FormData();
        formData.append("archivo", archivo);
        formData.append("numFactura", facturaSeleccionada);

        try {
          const response = await fetch(
            baseURL + "/api/Rips/CargarProcesarXMLFactura",
            {
              method: "POST",
              body: formData,
            }
          );

          const result = await response.json();

          if (result.exito) {
            setXmlValidado((prev) => ({
              ...prev,
              [facturaSeleccionada]: true,
            }));

            await obtenerFacturas(); // 🔄 Recargar después del envío

            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "XML validado con éxito",
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            setXmlValidado((prev) => ({
              ...prev,
              [facturaSeleccionada]: false,
            }));

            Swal.fire({
              icon: "warning",
              title: "Validación fallida",
              text: result.mensaje || "No se pudo validar el XML.",
            });
          }
        } catch (error) {
          console.error("Error al subir el XML:", error);

          setXmlValidado((prev) => ({
            ...prev,
            [facturaSeleccionada]: false,
          }));

          Swal.fire({
            icon: "error",
            title: "Error de conexión",
            text: "No se pudo procesar el archivo XML. Inténtalo más tarde.",
          });
        } finally {
          e.target.value = null;
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Formato inválido",
          text: "Por favor selecciona un archivo XML válido.",
        });
        e.target.value = null;
      }
    }
  };

  //Ver JSON
  const handleVerJSON = async (factura) => {
    setProcesandoRegistro(factura);
    try {
      const response = await axios.post(
        baseURL + `/api/Rips/GenerarJSON/${factura}`
      );

      const data = response.data;

      if (data.json) {
        const estadoFactura = datosFiltrados.find(
          (f) => f.factura === factura
        )?.estado;
        setJsonFactura(data.json);
        setFacturaEnPanel(factura);
        setEsEditable(estadoFactura === "Sin Enviar");
        setMostrarPanelJSON(true);
        setBusquedaJson("");
      } else {
        Swal.fire({
          icon: "warning",
          title: "Advertencia",
          text: "No se pudo obtener el JSON de la factura.",
        });
      }
    } catch (error) {
      console.error("Error al obtener el JSON:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.mensaje ||
          "Error desconocido al obtener el JSON.",
      });
    } finally {
      setProcesandoRegistro(null); // Desmarcar
    }
  };

  //Actualizar datos del json
  const actualizarJSON = async (numFactura, json, usuarioMod) => {
    try {
      setCargando(true);

      const response = await axios.post(baseURL + "/api/Rips/ActualizarJSON", {
        numFactura,
        json: json.replace(/[^a-zA-Z0-9{}":,\[\]\s\-:.]/g, ""),
        usuarioMod,
      });

      if (response.data.exito) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "JSON actualizado con éxito",
          showConfirmButton: false,
          timer: 3000,
        });

        setProcesandoRegistro(null);
        setMostrarPanelJSON(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al actualizar",
          text: response.data.mensaje || "Ocurrió un error al guardar el JSON.",
        });
      }
    } catch (error) {
      console.error("Error al actualizar el JSON:", error);
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text:
          error.response?.data?.mensaje ||
          "No se pudo actualizar el JSON debido a un error desconocido.",
      });
    } finally {
      setCargando(false);
      setProcesandoRegistro(null);
    }
  };

  //Consumir API para enviar RIPS JSON
  const enviarRipsJSON = async (numFactura, usuarioNotificacion, ambiente) => {
    try {
      setEnviandoRips(numFactura); //Bloquear el botón
      setProcesandoRegistro(numFactura); //Marcar el registro

      const response = await axios.post(baseURL + "/api/Rips/EnviarJSON", {
        numFactura,
        usuarioNotificacion,
        ambiente,
      });

      if (response.data.exito) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "JSON enviado con éxito",
          showConfirmButton: false,
          timer: 3000,
        });

        await obtenerFacturas(); // 🔄 Recargar después del envío
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al enviar el JSON",
          text: response.data.mensaje || "Ocurrió un error durante el envío.",
        });
      }
    } catch (error) {
      console.error("Error al enviar el JSON:", error);

      Swal.fire({
        icon: "warning",
        title: "Observaciones detectadas en el JSON",
        html: `
    <div style="text-align: left; font-size: 14px;">
      <p style="margin: 0 0 8px 0;"></p>
      <pre id="mensajeErrorHTML" style="background-color: #f8f9fa; padding: 10px; border-radius: 4px; white-space: pre-wrap; font-size: 13px; border: 1px solid #ddd;">
${error.response?.data?.mensaje || "Error desconocido"}
      </pre>
      <button id="btnCopiarHTML" class="swal2-confirm swal2-styled" 
        style="margin-top: 12px; background-color: #6c757d;">
        📋 Copiar mensaje
      </button>
    </div>
  `,
        showConfirmButton: false, // ⛔ Oculta botón "Cerrar"
        showCloseButton: true, // ✅ Muestra botón ❌
        customClass: {
          popup: "modal-ancho-custom",
        },
        didOpen: () => {
          const btn = document.getElementById("btnCopiarHTML");
          btn.addEventListener("click", () => {
            const contenido = document
              .getElementById("mensajeErrorHTML")
              .innerText.trim();
            navigator.clipboard.writeText(contenido);
            btn.innerText = "📋 Copiado";
            setTimeout(() => (btn.innerText = "📋 Copiar mensaje"), 1000);
          });
        },
      });
    } finally {
      setEnviandoRips(null);
      setProcesandoRegistro(null);
      setXmlValidado({});
    }
  };

  //Descargar archivos rips JSON
  const descargarRipsJSON = async (numFactura, ambiente) => {
    try {
      setDescargandoArchivos(numFactura); //Bloquear el botón
      setProcesandoRegistro(numFactura); //Marcar el registro

      const response = await axios.post(
        baseURL + "/api/Rips/DescargarArchivos",
        { numFactura, ambiente },
        { responseType: "blob" } // Importante para manejar archivos
      );

      // Obtener nombre del archivo desde las cabeceras
      const disposition = response.headers["content-disposition"];
      let nombreArchivo = `RIPS_${numFactura}.zip`;

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match?.length > 1) {
          nombreArchivo = decodeURIComponent(match[1]);
        }
      }

      // Guardar el archivo ZIP
      const blob = new Blob([response.data], { type: "application/zip" });
      nombreArchivo = `RIPS_${numFactura}.zip`;
      saveAs(blob, nombreArchivo);

      // Notificar éxito con Toast
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Descarga completada",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (error) {
      console.error("Error al descargar el archivo:", error);

      Swal.fire({
        icon: "error",
        title: "Error al descargar",
        text:
          error.response?.data?.mensaje ||
          "No se pudo completar la descarga. Intenta más tarde.",
      });
    } finally {
      setDescargandoArchivos(null);
      setProcesandoRegistro(null);
    }
  };

  //////////////
  // FUNCIONES
  /////////////

  // Función para limpiar y reestructurar el mensaje HTML
  const limpiarMensajeHtml = (mensajeHTML) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(mensajeHTML, "text/html");
    const text = doc.body.innerHTML;

    const observacionesMatch = text.match(
      /<b>Observaciones:<\/b>\s*(.*?)\s*<br\/?>/i
    );
    const descripcionMatch = text.match(
      /<b>Descripción:<\/b>\s*(.*?)\s*<br\/?>/i
    );
    const pathMatch = text.match(/<b>PathFuente:<\/b>\s*(.*?)\s*<br\/?>/i);
    const fuenteMatch = text.match(/<b>Fuente:<\/b>\s*(.*?)\s*<hr\/?>?/i);

    let resultado = "";
    if (observacionesMatch)
      resultado += `Observaciones: ${observacionesMatch[1].trim()}\n`;
    if (descripcionMatch)
      resultado += `Descripción: ${descripcionMatch[1].trim()}\n`;
    if (pathMatch) resultado += `PathFuente: ${pathMatch[1].trim()}\n`;
    if (fuenteMatch) resultado += `Fuente: ${fuenteMatch[1].trim()}\n`;

    return resultado.trim();
  };

  ///PROCESO MASIVO DE XML Y ENVIO
  const enviarArchivosXml = async () => {
    const archivos = archivoXmlRef.current.files;

    if (!archivos || archivos.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: "Debe seleccionar al menos un archivo XML.",
        showConfirmButton: false,
        timer: 3000,
        animation: false,
      });
      return;
    }

    const total = archivos.length;
    const resultados = []; // Para guardar estado de cada archivo

    // Mostrar el modal de carga SIN await
    Swal.fire({
      icon: "info",
      title: "Iniciando carga...",
      html: "Preparando archivos...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      showCloseButton: false,
      animation: false,
      didOpen: async () => {
        for (let i = 0; i < total; i++) {
          const archivo = archivos[i];
          const porcentaje = Math.round(((i + 1) / total) * 100);

          Swal.update({
            title: `📤 Cargando archivo ${i + 1} de ${total}`,
            html: `<strong>${archivo.name}</strong><br>${porcentaje}% completado`,
            icon: "info",
          });

          // Armar FormData
          const formData = new FormData();
          formData.append("archivo", archivo); // archivo XML
          formData.append(
            "req",
            JSON.stringify({
              numFactura: "",
              usuarioNotificacion: usuario,
              ambiente: ambiente,
            })
          );

          try {
            const response = await axios.post(
              baseURL + "/api/Rips/EnvioMasivoRips", // <-- Ajusta esto
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            const data = response.data;
          } catch (error) {
            let mensaje =
              error.response?.data?.mensaje ||
              error.response?.data?.Message ||
              error.message ||
              "Error desconocido";

            // Si contiene HTML con observaciones, limpiamos
            if (mensaje.includes("<b>") && mensaje.includes("Observaciones")) {
              mensaje = limpiarMensajeHtml(mensaje);
            }

            resultados.push(
              `❌ ${error.response?.data?.factura}\n${mensaje}\n\n`
            );
          }

          // Simula el tiempo de carga (reemplaza con tu llamada a API)
          await new Promise((resolve) => setTimeout(resolve, 500));
        }

        // Cuando termine todo
        Swal.update({
          title: "✅ Carga completada",
          html: `Se han enviado ${total} archivos XML correctamente.`,
          icon: "success",
        });

        await obtenerFacturas(); // 🔄 Recargar después del envío

        // Descargar archivo con resultados
        if (resultados.length > 0) {
          // Mostrar alerta para preguntar si desea descargar el archivo
          Swal.fire({
            icon: "warning",
            title: "Algunos archivos tuvieron errores",
            text: "¿Desea descargar el archivo con el detalle de los errores?",
            showCancelButton: true,
            confirmButtonText: "Sí, descargar",
            cancelButtonText: "No, gracias",
          }).then((result) => {
            if (result.isConfirmed) {
              const contenido = resultados.join("\n");
              const blob = new Blob([contenido], {
                type: "text/plain;charset=utf-8",
              });
              const url = URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = url;
              link.download = "resultado_envio_rips.txt";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
            }
          });
        }

        /*setTimeout(() => {
          Swal.close();
          setMostrarModalCargaXML(false);
        }, 3000);
        */
      },
    });
  };

  //Buscar, resaltar y editar cursor de cuando se edita el JSON en el TxtTarea
  // Asegúrate de que tu función de resaltado use DOS marcadores (ej. 📌$1📌)
  function resaltarCoincidenciasEnJson(json, termino) {
    try {
      let textoLimpio = json.replace(/📌/g, "");
      if (!termino.trim()) return textoLimpio;
      const regex = new RegExp(`(${termino})`, "gi");
      return textoLimpio.replace(regex, "📌$1📌"); // ¡DOS MARCADORES!
    } catch {
      return json;
    }
  }

  // SIMPLIFICAR EL HANDLER DEL INPUT DE BÚSQUEDA
  const handleBusquedaJsonChange = (e) => {
    if (textareaRef.current) {
      const currentMarkedText = textareaRef.current.value;
      const currentCursorPosition = textareaRef.current.selectionStart;

      // 1. CALCULAR LA DESCOMPENSACIÓN
      const markedSegment = currentMarkedText.substring(
        0,
        currentCursorPosition
      );
      const compensation =
        markedSegment.length - markedSegment.replace(/📌/g, "").length;

      // 2. GUARDAR la posición DESCOMPENSADA
      const newCursorPosClean = currentCursorPosition - compensation;
      setCursorPos(newCursorPosClean);
    }
    setBusquedaJson(e.target.value);
  };

  // Hook para Restaurar la Posición (Aplica Compensación)
  useEffect(() => {
    if (textareaRef.current && mostrarPanelJSON) {
      let newCursorPos = cursorPos;

      if (busquedaJson) {
        // Lógica de compensación: calcula cuántos marcadores hay ANTES de cursorPos
        const segmentLimpio = jsonFactura.substring(0, cursorPos);
        const segmentMarcado = resaltarCoincidenciasEnJson(
          segmentLimpio,
          busquedaJson
        );
        const compensation = segmentMarcado.length - segmentLimpio.length;
        newCursorPos = cursorPos + compensation;
      }

      // Forzar la posición final del cursor
      textareaRef.current.selectionStart = newCursorPos;
      textareaRef.current.selectionEnd = newCursorPos;
    }
  }, [jsonFactura, busquedaJson, mostrarPanelJSON]);
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-header  text-white">
            <h3 className="card-title titulo">📋 Consulta y Envíos de Rips</h3>
          </div>

          <div className="card-body">
            <div className="row">
              {/* Filtros */}
              <div className="col-md-4">
                <div className="form-group">
                  <label>🔍 Buscar por factura o CUV</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: FAC123 o 83d09c6c22c6735aff5b..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>📦 Estado</label>
                  <select
                    className="form-control"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="Enviado">Enviado</option>
                    <option value="Sin Enviar">Sin Enviar</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>📅 Rango de fecha</label>
                  <select
                    className="form-control"
                    value={rangoFecha}
                    onChange={(e) => setRangoFecha(e.target.value)}
                  >
                    <option value="7">Últimos 7 días</option>
                    <option value="30">Últimos 30 días</option>
                    <option value="90">Últimos 90 días</option>
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="btn btn-outline-dark btn-block shadow-sm animate-masivo text-white"
                    style={{ backgroundColor: "#2E2E2E", fontSize: "15px" }}
                    onClick={() => setMostrarModalCargaXML(true)}
                  >
                    <i className="fas fa-file-upload mr-2"></i>
                    Proceso Masivo
                  </button>
                </div>
              </div>
            </div>

            <input
              type="file"
              accept=".xml"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleProcesarXMLSeleccionado}
            />

            {/* Tabla de resultados */}
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-no-vertical-borders">
                <thead
                  className="text-white"
                  style={{ backgroundColor: "#003F88" }}
                >
                  <tr>
                    <th>Factura</th>
                    <th>CUV</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>XML Factura</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {datosPaginados.length > 0 ? (
                    datosPaginados.map(
                      (item, i) => (
                        console.log(item),
                        (
                          <tr
                            key={i}
                            className={
                              procesandoRegistro === item.factura
                                ? "table-secondary"
                                : ""
                            }
                          >
                            <td>{item.factura}</td>
                            <td>
                              {item.cuv ? (
                                <span title={item.cuv}>
                                  {item.cuv.slice(0, 34) + "..."}
                                  <button
                                    className="btn btn-sm btn-outline-secondary ml-2"
                                    onClick={() =>
                                      item.cuv && handleCopy(item.cuv)
                                    }
                                    title="Copiar CUV completo"
                                  >
                                    {copiedCuv === item.cuv ? (
                                      <FaCheck />
                                    ) : (
                                      <FaCopy />
                                    )}
                                  </button>
                                </span>
                              ) : (
                                <em>Sin CUV</em>
                              )}
                            </td>
                            <td>
                              <span
                                className={`badge ${
                                  item.estado === "Enviado"
                                    ? "badge-success"
                                    : "badge-secondary"
                                }`}
                              >
                                {item.estado}
                              </span>
                            </td>
                            <td>{item.fecha}</td>
                            <td>
                              <button
                                className="btn btn-cargar-xml "
                                onClick={() => handleCargarXML(item.factura)}
                                disabled={
                                  item.estado === "Enviado" ||
                                  item.xmlFevFile !== null
                                }
                              >
                                <FaFileUpload /> Subir XML
                              </button>
                              {xmlValidado[item.factura] && (
                                <div className="text-success mt-1">
                                  <FaCheck className="mr-1" />
                                  <span style={{ fontSize: "10px" }}>
                                    XML Validado
                                  </span>
                                </div>
                              )}
                            </td>
                            <td>
                              <div className="d-flex flex-wrap">
                                <button
                                  className={`btn btn-sm mr-1 ${
                                    item.estado === "Enviado" ||
                                    item.xmlFevFile === null ||
                                    enviandoRips === item.factura
                                      ? "btn btn-accion disabled"
                                      : "btn btn-accion"
                                  }`}
                                  onClick={() =>
                                    enviarRipsJSON(
                                      item.factura,
                                      usuario,
                                      ambiente
                                    )
                                  }
                                  disabled={
                                    item.estado === "Enviado" ||
                                    item.xmlFevFile === null ||
                                    enviandoRips === item.factura
                                  }
                                >
                                  {enviandoRips === item.factura ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm"></span>
                                      &nbsp;Enviando...
                                    </>
                                  ) : (
                                    <>
                                      <FaPaperPlane /> Enviar RIPS
                                    </>
                                  )}
                                </button>

                                <button
                                  className="btn btn-accion mr-1"
                                  onClick={() => handleVerJSON(item.factura)}
                                >
                                  <FaEdit /> Ver JSON
                                </button>

                                <button
                                  className={`btn btn-sm mr-1 ${
                                    item.estado === "Sin Enviar" ||
                                    descargandoArchivos === item.factura
                                      ? "btn btn-accion disabled"
                                      : "btn btn-accion"
                                  }`}
                                  onClick={() =>
                                    descargarRipsJSON(item.factura, ambiente)
                                  }
                                  disabled={
                                    item.estado === "Sin Enviar" ||
                                    descargandoArchivos === item.factura
                                  }
                                >
                                  {descargandoArchivos === item.factura ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm"></span>
                                      &nbsp;Descargando...
                                    </>
                                  ) : (
                                    <>
                                      <FaDownload /> Descargar
                                    </>
                                  )}
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No se encontraron resultados.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Paginación */}
            {totalPaginas > 1 && (
              <div className="mt-3">
                {Array.from({ length: totalPaginas }).map((_, index) => (
                  <button
                    key={index}
                    className={`btn btn-sm ${
                      paginaActual === index + 1
                        ? "btn-secondary"
                        : "btn-outline-secondary"
                    } mr-1`}
                    onClick={() => setPaginaActual(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* MODAL (sin navy) */}
        {mostrarPanelJSON && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header text-white"
                  style={{ backgroundColor: "#003F88" }}
                >
                  <h5 className="modal-title">
                    📄 Ver o Editar - JSON Factura {facturaEnPanel}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => {
                      setMostrarPanelJSON(false);
                      setProcesandoRegistro(null);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="🔍 Buscar en el JSON"
                      value={busquedaJson}
                      onChange={handleBusquedaJsonChange} // <-- Usar la función que maneja la posición
                    />
                  </div>

                  <div className="form-group">
                    <textarea
                      ref={textareaRef} // <-- Asegúrate de que esta línea esté
                      className="form-control"
                      rows="15"
                      readOnly={!esEditable}
                      // El 'value' siempre muestra el JSON marcado si hay búsqueda, o el JSON limpio si no la hay.
                      value={
                        busquedaJson
                          ? resaltarCoincidenciasEnJson(
                              jsonFactura,
                              busquedaJson
                            )
                          : jsonFactura
                      }
                      // DENTRO DEL <textarea> en el onChange:
                      // DENTRO DEL <textarea> en el onChange:
                      onChange={(e) => {
                        const currentMarkedText = e.target.value;
                        const currentCursorPosition = e.target.selectionStart;

                        // 1. CALCULAR LA DESCOMPENSACIÓN (inversa): Averiguar cuántos 📌 hay antes del cursor
                        const markedSegment = currentMarkedText.substring(
                          0,
                          currentCursorPosition
                        );
                        // Cuántos caracteres extra hay: (longitud marcada - longitud limpia)
                        const compensation =
                          markedSegment.length -
                          markedSegment.replace(/📌/g, "").length;

                        // 2. GUARDAR la posición DESCOMPENSADA (posición en el texto limpio)
                        const newCursorPosClean =
                          currentCursorPosition - compensation;
                        setCursorPos(newCursorPosClean);

                        // 3. Limpieza del valor y actualización de estado (¡Mantenemos la búsqueda activa!)
                        const valorLimpioParaEstado = currentMarkedText.replace(
                          /📌/g,
                          ""
                        );
                        setJsonFactura(valorLimpioParaEstado);
                      }}
                    />
                  </div>

                  {!esEditable && (
                    <div className="alert alert-warning text-dark">
                      ⚠️ El JSON no puede editarse porque el estado es
                      "Enviado".
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  {esEditable && (
                    <button
                      className="btn btn-success"
                      disabled={cargando}
                      onClick={() =>
                        actualizarJSON(facturaEnPanel, jsonFactura, usuario)
                      }
                    >
                      {cargando ? (
                        <>
                          <span className="spinner-border spinner-border-sm"></span>
                          &nbsp;Guardando...
                        </>
                      ) : (
                        "Guardar"
                      )}
                    </button>
                  )}
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setMostrarPanelJSON(false);
                      setProcesandoRegistro(null);
                    }}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* MODAL CARGAR ARCHIVOS XML */}
        {mostrarModalCargaXML && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg " role="document">
              <div className="modal-content">
                <div
                  className="modal-header text-white"
                  style={{ backgroundColor: "#003F88" }}
                >
                  <h5 className="modal-title">
                    📤 Carga Masiva de Archivos XML
                  </h5>
                  <button
                    type="button"
                    className="close text-white"
                    onClick={() => setMostrarModalCargaXML(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <label className="mb-2 font-weight-bold">
                    Seleccione los archivos XML de los JSON a enviar:
                  </label>
                  <input
                    ref={archivoXmlRef}
                    type="file"
                    className="form-control"
                    accept=".xml"
                    multiple
                  />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setMostrarModalCargaXML(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={() => enviarArchivosXml()}
                  >
                    <i className="fas fa-paper-plane mr-2"></i>
                    Enviar todos los RIPS con XML
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultaEnvio;
